//Validate if a value is within a given array of values
export const valueIsWithin = (array, value)=> array.some(element=>element==value);
//Validdate if a string is empty
export const isEmpty = value=> value===undefined || value===null || !value.trim().length>0;
//Validdate if a string is not empty
export const isNotEmpty = value=>!isEmpty(value);



// WEBPACK FOOTER //
// ./src/helpers/validators.js